import React from "react";
import { Box, Grid, Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const AudioModal = ({ modalOpen, handleClose, audioFile }) => {
  return (
    <Modal open={modalOpen} onClose={handleClose}>
      <Box sx={audioModalStyles}>
        <Grid container direction={"column"}>
          <Grid container justifyContent={"flex-end"}>
            <CloseIcon
              onClick={handleClose}
              style={{ cursor: "pointer", marginTop: 10, marginBottom: 10 }}
            />
          </Grid>
          <Grid container>
            <audio controls autoPlay playsInline src={audioFile} />
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default AudioModal;

const audioModalStyles = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  // width: "50% ",
  // height: "70%",
  bgcolor: "#fff",
  borderRadius: 2,
  p: 2,
};
